import React, { useState, useEffect } from "react";
import mermaid from "mermaid";
import Spinner from './Spinner'

export const Mermaid = ({ id, content }) => {

    const [svg, setSvg] = useState(null)

    useEffect(() => {
        mermaid.mermaidAPI.initialize({
            startOnLoad: false,
            theme: 'default',
            themeCSS: '.label { font-family: Roboto; font-size:14px; text-align: center; }',
            flowchart: { 
                curve: 'basis',
                htmlLabels: true
              }
        })

        mermaid.mermaidAPI.render(id, content, svg => {
            setSvg(svg)
        })
    }, [id, content])


    return (
        <>
            {!svg && <Spinner />
            }
            {svg && <div dangerouslySetInnerHTML={{ __html: svg }} />
            }
        </>
    )
}

export default Mermaid